import React, { useState, useEffect } from 'react';
import { Link,useNavigate, useSearchParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { api } from '../services';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { setAuthData } from '../store/slices/authSlice';
const oId=process.env.REACT_APP_OID;

export const LoginVerify = () => {
  const [timeLeft, setTimeLeft] = useState(120);
  const [showResendButton, setShowResendButton] = useState(false);
  const [searchParams] = useSearchParams();
  const ovFlag = searchParams.get('ov');
  const queryOID = searchParams.get('OID') || oId || '1';
  const [key, setKey] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [IsCompeleteProfile, setIsCompeleteProfile] = useState('');
  const [verificationError, setVerificationError] = useState(''); // Add error state
  const [verificationCode, setVerificationCode] = useState(''); // Add state for verification code
  const navigate = useNavigate();
  const { register, handleSubmit, setValue, watch } = useForm();
  const dispatch = useDispatch();
  const currentPath = window.location.pathname;
  const { paymentData } = useSelector((state) => state.payment);

  // Function to normalize Persian/Arabic digits to English digits
  const normalizeDigits = (input) => {
    if (!input) return '';
    return String(input)
      .replace(/[\u06F0-\u06F9]/g, (d) => String(d.charCodeAt(0) - 1776)) // Persian digits
      .replace(/[\u0660-\u0669]/g, (d) => String(d.charCodeAt(0) - 1632)); // Arabic-Indic digits
  };

  // Function to handle verification code input
  const handleVerificationCodeChange = (e) => {
    const value = e.target.value;
    // Allow only digits (both Persian/Arabic and English)
    const normalizedValue = normalizeDigits(value);
    const cleanValue = normalizedValue.replace(/[^0-9]/g, '');
    
    // Update the form value
    setValue('code', cleanValue);
    setVerificationCode(cleanValue);
    
    // Clear any previous errors when user starts typing
    if (verificationError) {
      setVerificationError('');
    }
  };

  useEffect(() => {
    // Log initial paymentData state
    console.log('Initial paymentData state:', paymentData);
    
    setKey(searchParams.get('key'));
    setPhoneNumber(searchParams.get('phoneNumber'));
    setIsCompeleteProfile(searchParams.get('IsCompeleteProfile'));

    // بررسی و ذخیره doctorId از URL
    const doctorIdFromUrl = searchParams.get('doctorId');
    if (doctorIdFromUrl) {
      console.log('Debug - Setting doctorId from URL:', doctorIdFromUrl);
      localStorage.setItem('doctor_id', doctorIdFromUrl);
    }

    // پاک کردن اطلاعات قبلی فقط اگر از صفحه نوبت‌دهی نیامده باشد
    const loginSource = localStorage.getItem("loginSource");
    const doctorId = localStorage.getItem("doctor_id");
    const dateSelected = localStorage.getItem("date_n");
    const timeSelected = localStorage.getItem("time");

    console.log('Debug - Login Verification State:', {
      loginSource,
      doctorId,
      dateSelected,
      timeSelected,
      doctorIdFromUrl,
      sortOrder: paymentData.sortOrder // اضافه کردن sortOrder به لاگ
    });

    if (!loginSource && !doctorId && !dateSelected && !timeSelected) {
      // پاک کردن اطلاعات قبلی در زمان لود صفحه
      localStorage.removeItem('time');
      localStorage.removeItem('num');
      localStorage.removeItem('date_n');
      localStorage.removeItem('doctor_id');
      localStorage.removeItem('doctor_name');
      localStorage.removeItem('doctor_famil');
      localStorage.removeItem('Price');
      localStorage.removeItem('payment_time');
      localStorage.removeItem('ServiceCategoryID');
    }

    // اضافه کردن event listener برای پاک کردن اطلاعات در زمان بستن مرورگر
    const handleBeforeUnload = () => {
      localStorage.removeItem('time');
      localStorage.removeItem('num');
      localStorage.removeItem('date_n');
      localStorage.removeItem('doctor_id');
      localStorage.removeItem('doctor_name');
      localStorage.removeItem('doctor_famil');
      localStorage.removeItem('Price');
      localStorage.removeItem('payment_time');
      localStorage.removeItem('ServiceCategoryID');
      localStorage.removeItem('loginSource');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      // پاک کردن اطلاعات در زمان خروج از کامپوننت
      localStorage.removeItem('time');
      localStorage.removeItem('num');
      localStorage.removeItem('date_n');
      localStorage.removeItem('doctor_id');
      localStorage.removeItem('doctor_name');
      localStorage.removeItem('doctor_famil');
      localStorage.removeItem('Price');
      localStorage.removeItem('payment_time');
      localStorage.removeItem('ServiceCategoryID');
      localStorage.removeItem('loginSource');
    };
  }, [searchParams]);

  useEffect(() => {
    if (paymentData.sortOrder) {
      console.log('Selected SortOrder:', paymentData.sortOrder);
    }
  }, [paymentData.sortOrder]);

  const getProfileData = async (key) => {
        try 
        {
          const response = await api.get(`Home/GetProfileInfo?SesID=${key}&OID=${oId}`);
          let data = response.data;
  
          if (typeof data === 'string') 
          {
            try 
            {
              data = JSON.parse(data);
            } 
            catch (error) 
            {
              console.error('Invalid JSON string:', data);
              return;
            }
          }
  
          if (data.ErrorMessage) 
          {
            navigate('/login');
            return;
          }
          localStorage.setItem("patientID",data[0]?.PatientID);
          localStorage.setItem('Fname', data[0]?.Fname);
          localStorage.setItem('Lname', data[0]?.Lname);
        } 
        catch (error) {
          console.error('Error fetching profile info:', error);
          navigate('/login');
        }
  };

  const onSubmit = async (data) => {
    try {
      setVerificationError(''); // Clear any previous errors
      console.log('Form submission - Current sortOrder:', paymentData.sortOrder);
      
      // Use the verificationCode state instead of form data
      const code = verificationCode;
      
      // Validate that code is not empty
      if (!code || code.length === 0) {
        setVerificationError('لطفا کد تایید را وارد کنید');
        return;
      }
      
      // Validate code length (typically 4-6 digits)
      if (code.length < 4 || code.length > 6) {
        setVerificationError('کد تایید باید بین ۴ تا ۶ رقم باشد');
        return;
      }
      const response = await api.get(
        `Home/LoginWithOtpCode?MobileNumber=${phoneNumber}&OtpCode=${code}&OID=${oId}`,
      );

      let responseData = response.data;
      if (typeof responseData === 'string') {
        try {
          responseData = JSON.parse(responseData);
        } catch (error) {
          console.error('Invalid JSON string:', responseData);
          throw new Error('Failed to parse JSON');
        }
      }

      if (responseData?.ErrorMessage) {
        setVerificationError('کد وارد شده صحیح نمی‌باشد. لطفا مجدداً تلاش کنید.');
        return;
      }

      if (responseData?.Key) {
        // ذخیره اطلاعات کاربر در localStorage
        localStorage.setItem('phoneNumber', phoneNumber);
        localStorage.setItem('key', responseData.Key);
        localStorage.setItem('code', code);

        // دریافت اطلاعات پروفایل کاربر
        const profileResponse = await api.get(`Home/GetProfileInfo?SesID=${responseData.Key}&OID=${oId}`);
        let profileData = profileResponse.data;
        
        if (typeof profileData === 'string') {
          try {
            profileData = JSON.parse(profileData);
          } catch (error) {
            console.error('Invalid JSON string:', profileData);
            throw new Error('Failed to parse profile data');
          }
        }

        if (profileData?.ErrorMessage) {
          throw new Error(profileData.ErrorMessage);
        }

        // ذخیره اطلاعات کاربر در Redux store
        dispatch(setAuthData({
          key: responseData.Key,
          phoneNumber: phoneNumber,
          userData: profileData[0]
        }));

        // ذخیره اطلاعات در localStorage
        localStorage.setItem("patientID", profileData[0]?.PatientID);
        localStorage.setItem('Fname', profileData[0]?.Fname);
        localStorage.setItem('Lname', profileData[0]?.Lname);

        // اگر پارامتر ov=1 آمده باشد -> بعد از تایید OTP به Paymentvo هدایت شود
        
        
        // Get the ServiceCategoryID from localStorage
        const serviceCategoryId = localStorage.getItem('ServiceCategoryID');

        // Check if coming from category 49
        if (serviceCategoryId === '49') {
          // If profile is not complete, save return URL
          if (responseData?.IsCompeleteProfile === '0') {
            localStorage.setItem('returnUrl', '/doctoronline');
            navigate(`/editprofile?ov=${ovFlag}`);
            return;
          }
          // If profile is complete, go directly to DoctorOnline
          navigate('/doctoronline');
          return;
        }

        // بررسی شرایط هدایت
        const dateSelected = localStorage.getItem("date_n");
        const timeSelected = localStorage.getItem("time");
        const loginSource = localStorage.getItem("loginSource");
        const doctorId = localStorage.getItem("doctor_id");
        const serviceDoctorId = localStorage.getItem("ServiceDoctorID");

        console.log('Debug - LoginVerify Values:', {
          IsCompeleteProfile: responseData?.IsCompeleteProfile,
          dateSelected,
          timeSelected,
          loginSource,
          currentPath,
          doctorId,
          serviceDoctorId,
          sortOrder: paymentData.sortOrder,
          localStorage: {
            doctor_id: localStorage.getItem('doctor_id'),
            ServiceDoctorID: localStorage.getItem('ServiceDoctorID'),
            date_n: localStorage.getItem('date_n'),
            time: localStorage.getItem('time')
          }
        });

        // اگر فقط sortOrder: 5 باشد و بقیه مقادیر null باشند
        if (paymentData.sortOrder === 5 && 
            !dateSelected && 
            !timeSelected && 
            !doctorId && 
            !serviceDoctorId) {
          console.log('Redirecting to DoctorOnline - Only sortOrder:5 is present');
          navigate('/doctoronline');
          return;
        }

        // اگر پروفایل تکمیل نشده باشد
        if (responseData?.IsCompeleteProfile === '0') {
          console.log('Profile not complete - redirecting to editprofile');
          
          // Check if we have a specific return URL (for category 49)
          const returnUrl = localStorage.getItem('returnUrl');
          
          // ذخیره اطلاعات نوبت در localStorage اگر وجود داشته باشد
          if (dateSelected && timeSelected && doctorId && serviceDoctorId) {
            const appointmentData = {
              date: dateSelected,
              time: timeSelected,
              doctorId,
              serviceDoctorId,
              doctorName: localStorage.getItem('doctor_name'),
              doctorFamil: localStorage.getItem('doctor_famil'),
              price: localStorage.getItem('Price'),
              serviceCategoryId: localStorage.getItem('ServiceCategoryID'),
              num: localStorage.getItem('num')
            };
            localStorage.setItem('pendingAppointment', JSON.stringify(appointmentData));
            localStorage.setItem('returnToPayment', 'true');
          } else if (returnUrl) {
            // If we have a return URL but no appointment data, save it for after profile completion
            localStorage.setItem('returnAfterProfile', returnUrl);
          }
          
          navigate(`/editprofile?ov=${ovFlag}`);
          return;
        }

        // بررسی تاریخ و زمان برای کاربران موجود
        if (dateSelected && timeSelected && doctorId && serviceDoctorId) {
          console.log('Debug - Before payment redirect:', {
            dateSelected,
            timeSelected,
            doctorId,
            serviceDoctorId,
            price: localStorage.getItem('Price'),
            serviceCategoryId: localStorage.getItem('ServiceCategoryID'),
            doctorName: localStorage.getItem('doctor_name'),
            doctorFamil: localStorage.getItem('doctor_famil'),
            num: localStorage.getItem('num')
          });

          // ذخیره اطلاعات نوبت در localStorage
          const appointmentData = {
            date: dateSelected,
            time: timeSelected,
            doctorId,
            serviceDoctorId,
            doctorName: localStorage.getItem('doctor_name'),
            doctorFamil: localStorage.getItem('doctor_famil'),
            price: localStorage.getItem('Price'),
            serviceCategoryId: localStorage.getItem('ServiceCategoryID'),
            num: localStorage.getItem('num')
          };

          // ذخیره اطلاعات در localStorage به صورت جداگانه
          localStorage.setItem('date_n', dateSelected);
          localStorage.setItem('time', timeSelected);
          localStorage.setItem('doctor_id', doctorId);
          localStorage.setItem('ServiceDoctorID', serviceDoctorId);
          localStorage.setItem('doctor_name', localStorage.getItem('doctor_name'));
          localStorage.setItem('doctor_famil', localStorage.getItem('doctor_famil'));
          localStorage.setItem('Price', localStorage.getItem('Price'));
          localStorage.setItem('ServiceCategoryID', localStorage.getItem('ServiceCategoryID'));
          localStorage.setItem('num', localStorage.getItem('num'));

          // ذخیره کل اطلاعات در یک آبجکت
          localStorage.setItem('appointmentData', JSON.stringify(appointmentData));
          
          console.log('Debug - Stored appointment data:', appointmentData);
          console.log('Debug - Stored localStorage values:', {
            date_n: localStorage.getItem('date_n'),
            time: localStorage.getItem('time'),
            doctor_id: localStorage.getItem('doctor_id'),
            ServiceDoctorID: localStorage.getItem('ServiceDoctorID'),
            doctor_name: localStorage.getItem('doctor_name'),
            doctor_famil: localStorage.getItem('doctor_famil'),
            Price: localStorage.getItem('Price'),
            ServiceCategoryID: localStorage.getItem('ServiceCategoryID'),
            num: localStorage.getItem('num')
          });
          if (ovFlag === '1') {
            const CategoryID = searchParams.get('CategoryID') || localStorage.getItem('ServiceCategoryID') || '';
            const CategoryName = searchParams.get('CategoryName') || localStorage.getItem('ServiceCategoryName') || '';
            const OIDparam = queryOID;
            navigate(`/Paymentvo?OID=${encodeURIComponent(OIDparam)}&CategoryID=${encodeURIComponent(CategoryID)}&CategoryName=${encodeURIComponent(CategoryName)}`);
            return;
          }
          navigate('/Payment');
          return;
        }

        // اگر پروفایل تکمیل شده دارد اما نوبت انتخاب نکرده است
        if (responseData?.IsCompeleteProfile === '1') {
          console.log('Profile complete but no appointment selected - redirecting to history');
          // پاک کردن اطلاعات قبلی نوبت
          localStorage.removeItem('time');
          localStorage.removeItem('num');
          localStorage.removeItem('date_n');
          localStorage.removeItem('doctor_id');
          localStorage.removeItem('doctor_name');
          localStorage.removeItem('doctor_famil');
          localStorage.removeItem('Price');
          localStorage.removeItem('payment_time');
          localStorage.removeItem('ServiceCategoryID');
          localStorage.removeItem('ServiceDoctorID');
          localStorage.removeItem('appointmentData');
          localStorage.removeItem('pendingAppointment');
          localStorage.removeItem('returnToPayment');
          
          navigate('/history');
          return;
        }

        // بررسی منبع ورود
        if (loginSource === 'main' || loginSource === 'login' || !loginSource) {
          console.log('From main/login page - redirecting to history');
          // پاک کردن اطلاعات قبل از ریدایرکت
          localStorage.removeItem('time');
          localStorage.removeItem('num');
          localStorage.removeItem('date_n');
          localStorage.removeItem('doctor_id');
          localStorage.removeItem('doctor_name');
          localStorage.removeItem('doctor_famil');
          localStorage.removeItem('Price');
          localStorage.removeItem('payment_time');
          localStorage.removeItem('ServiceCategoryID');
          localStorage.removeItem('ServiceDoctorID');
          localStorage.removeItem('loginSource');
          localStorage.removeItem('paymentData');
          navigate('/history');
          return;
        }

        if (loginSource === 'doctorlist' || loginSource === 'doctor') {
          console.log('From doctor page - redirecting to payment');
          navigate('/Payment');
          return;
        }

        if (currentPath.includes('/appointment') || loginSource === 'appointment') {
          console.log('From appointment page - redirecting to history');
          navigate('/history');
          return;
        }

        // در صورتی که هیچ شرطی برقرار نباشد
        console.log('No specific conditions met - redirecting to history');
        // پاک کردن اطلاعات قبل از ریدایرکت
        localStorage.removeItem('time');
        localStorage.removeItem('num');
        localStorage.removeItem('date_n');
        localStorage.removeItem('doctor_id');
        localStorage.removeItem('doctor_name');
        localStorage.removeItem('doctor_famil');
        localStorage.removeItem('Price');
        localStorage.removeItem('payment_time');
        localStorage.removeItem('ServiceCategoryID');
        localStorage.removeItem('ServiceDoctorID');
        localStorage.removeItem('loginSource');
        localStorage.removeItem('paymentData');
        navigate('/history');
      }
    } catch (error) {
      console.error('Error in login process:', error);
      setVerificationError('خطا در ورود. لطفا مجدداً تلاش کنید.');
    }
  };

  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
      return () => clearInterval(timerId);
    } else {
      setShowResendButton(true);
    }
  }, [timeLeft]);

  const handleResendCode = () => {
    setTimeLeft(120);
    setShowResendButton(false);
    console.log('Code resent');
  };

  return (
    <section className="container maxw mb-5">
       <div className="row mb-4 mt-2">
                <div className="col-lg-12 path">
                  <ul>
                    <li>
                      <Link className='text-decoration-none' to="/">صفحه اصلی</Link>
                      <FontAwesomeIcon icon={faAngleLeft} className="mr-2" />
                    </li>
                    <li>
                      <span>  تایید شماره موبایل</span>
                    </li>
                  </ul>
                </div>
              </div>
      <div className="row gap-3 justify-content-center">
        <div className="col-lg-5 card p-3 shadow rounded-3 mx-2">
          <div className="login-body d-flex flex-column align-items-center pt-4">
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="d-flex flex-column align-items-center w-100"
            >
              <div className="form-group text-center w-75">
                <h6 className="mb-3">
                  جهت ثبت نوبت کد ارسال شده به شماره موبایل {phoneNumber} کد را وارد نمایید
                </h6>
                <input
                  type="text"
                  id="LoginVerifyCode"
                  className="form-control rounded-input mb-3"
                  placeholder="کد تایید"
                  style={{
                    borderRadius: '10px',
                    padding: '10px',
                    fontSize: '16px',
                    textAlign: 'right',
                  }}
                  onChange={handleVerificationCodeChange}
                  value={verificationCode}
                  maxLength="6"
                />
                  <small className="text-muted mb-3 d-block">
                    کد تایید را وارد کنید (فارسی یا انگلیسی)
                  </small>
                  {verificationError && (
                    <div className="alert alert-danger mb-3" role="alert">
                      {verificationError}
                    </div>
                  )}
                <button
                  type="submit"
                  name="verify"
                  id="verify"
                  className="btn btn-primary w-100 mb-3"
                >
                  تایید
                </button>
                {showResendButton ? (
                  <button
                    onClick={handleResendCode}
                    className="btn btn-secondary w-100"
                  >
                    ارسال مجدد کد
                  </button>
                ) : (
                  <p className="mb-0">زمان باقی مانده: {timeLeft} ثانیه</p>
                )}
                
              </div>
            </form>
          </div>
        </div>
        <div className="col-lg-5 card p-3 shadow rounded-3 mx-2">
          <img
            src={'/Img/account-verification-with-password-3d-padlock.jpg'}
            className="w-100 h-100"
            alt="login"
            style={{ objectFit: 'cover' }}
          />
        </div>
      </div>
    </section>
  );
};